/**
 * HeaderGlobalAction.tsx — ikon-knapp i header (høyre)
 *
 * Ren React-komponent som erstatter cds-header-global-action.
 * Viser et ikon, toggler panel ved klikk.
 *
 * Props:
 * - icon: React-ikon-komponent (f.eks. <SearchIcon />)
 * - label: aria-label for tilgjengelighet
 * - active: om knappen er aktiv (panel åpent)
 * - onClick: klikk-handler
 */

import { ReactNode } from 'react';
import styles from './header-global-action.module.css';

interface HeaderGlobalActionProps {
  icon: ReactNode;
  label: string;
  active?: boolean;
  onClick?: () => void;
  /** Toggle-knapp uten panel: gir aria-pressed i stedet for aria-expanded. */
  pressed?: boolean;
  /** Valgfritt overlay (f.eks. ulest-dott) — posisjoneres over ikonet. */
  children?: ReactNode;
}

export default function HeaderGlobalAction({
  icon,
  label,
  active = false,
  pressed,
  onClick,
  children,
}: HeaderGlobalActionProps) {
  return (
    <button
      type="button"
      className={active ? styles.actionActive : styles.action}
      aria-label={label}
      aria-pressed={pressed}
      aria-expanded={pressed === undefined ? active : undefined}
      onClick={onClick}
    >
      <span className={styles.iconBox}>
        {icon}
      </span>
      {children}
    </button>
  );
}
